import { TypeContext } from '@/context/TypeContextProvider';
import React, { useContext } from 'react'

export default function ProductToggle() {

  const type = useContext(TypeContext);

  const changeType = (e: any) => {
    type.updateProductType(e.target.value);
  }

  return (
    <div>
        <select
            className={`mr-6 rounded-xl border-2 bg-cta text-white`}
            onChange={changeType}
            value={type.productType}
        >
            <option value="instrument">Instrument</option>
            <option value="starter">Starter & Panel</option>
        </select>
    </div>
  )
}
